import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize20 {
  size?: '20';
}
type OverrideIconSize = OverrideIconSize20;

const SvgComponent = ({
  size = '20',
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '20') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.364 3.63604C14.6066 1.87868 11.7574 1.87868 10 3.63604L8.23226 5.4038C8.037 5.59907 8.037 5.91565 8.23226 6.11091C8.42752 6.30617 8.7441 6.30617 8.93937 6.11091L10.7071 4.34314C12.074 2.97631 14.29 2.97631 15.6569 4.34314C17.0237 5.70998 17.0237 7.92606 15.6569 9.29289L13.8891 11.0607C13.6939 11.2559 13.6939 11.5725 13.8891 11.7678C14.0844 11.963 14.401 11.963 14.5962 11.7678L16.364 10C18.1213 8.24264 18.1213 5.3934 16.364 3.63604ZM6.11094 8.93934C6.3062 8.74408 6.3062 8.42749 6.11094 8.23223C5.91568 8.03697 5.59909 8.03697 5.40383 8.23223L3.63607 10C1.87871 11.7574 1.87871 14.6066 3.63607 16.364C5.39342 18.1213 8.24267 18.1213 10 16.364L11.7678 14.5962C11.9631 14.4009 11.9631 14.0843 11.7678 13.8891C11.5725 13.6938 11.2559 13.6938 11.0607 13.8891L9.29292 15.6569C7.92608 17.0237 5.71001 17.0237 4.34317 15.6569C2.97634 14.29 2.97634 12.0739 4.34317 10.7071L6.11094 8.93934ZM12.8285 7.17157C12.6332 6.97631 12.3166 6.97631 12.1213 7.17157L7.1716 12.1213C6.97634 12.3166 6.97634 12.6332 7.1716 12.8284C7.36686 13.0237 7.68344 13.0237 7.87871 12.8284L12.8285 7.87868C13.0237 7.68341 13.0237 7.36683 12.8285 7.17157Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 20 입니다.
 *
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'link');
export default IconComponent;
